// @ts-nocheck
import * as Types from '../../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ElevationDetailsQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  planPackageVersionId: Types.Scalars['ID']['input'];
}>;


export type ElevationDetailsQuery = { __typename?: 'Query', readyPlanOption: { __typename?: 'ReadyPlanOption', id: string, assets: Array<{ __typename?: 'ReadyPlanAsset', id: string, isCoverPhoto: boolean, asset: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } }>, programData: { __typename?: 'ProgramData', id: string, stories?: number | null | undefined, bedrooms?: number | null | undefined, firstFloorBedrooms?: number | null | undefined, closetsInPrimarySuite?: number | null | undefined, fullBaths?: number | null | undefined, halfBaths?: number | null | undefined, diningRoom?: number | null | undefined, casualDining?: number | null | undefined, mediaRooms?: number | null | undefined, loftGameFlexRooms?: number | null | undefined, offices?: number | null | undefined, workspaces?: number | null | undefined, garageAttached?: number | null | undefined, garageDetached?: number | null | undefined, garagePort?: number | null | undefined, depthInFeet?: number | null | undefined, widthInFeet?: number | null | undefined, minLotSizeInSqft?: number | null | undefined, minLotDepthInFeet?: number | null | undefined, minLotWidthInFeet?: number | null | undefined, buildingHeightInFeet?: number | null | undefined, netBuildableSqft?: number | null | undefined, grossBuildableSqft?: number | null | undefined, permittableSqft?: number | null | undefined, sellableAboveGroundSqft?: number | null | undefined, grossBelowGroundSqft?: number | null | undefined, sellableBelowGroundSqft?: number | null | undefined, imperviousSqft?: number | null | undefined, sellableSqft?: number | null | undefined, unfinishedBelowGroundSqft?: number | null | undefined, primaryBedroom?: { __typename?: 'ProgramDataPrimaryBedroomConfigDetail', code: Types.ProgramDataPrimaryBedroomConfig, name: string } | null | undefined, basementConfig?: { __typename?: 'ProgramDataBasementConfigDetail', code: Types.ProgramDataBasementConfig, name: string } | null | undefined, garageConfiguration?: { __typename?: 'ProgramDataGarageConfigDetail', code: Types.ProgramDataGarageConfig, name: string } | null | undefined } } };

export type ElevationDetails_ReadyPlanOptionFragment = { __typename?: 'ReadyPlanOption', id: string, assets: Array<{ __typename?: 'ReadyPlanAsset', id: string, isCoverPhoto: boolean, asset: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } }>, programData: { __typename?: 'ProgramData', id: string, stories?: number | null | undefined, bedrooms?: number | null | undefined, firstFloorBedrooms?: number | null | undefined, closetsInPrimarySuite?: number | null | undefined, fullBaths?: number | null | undefined, halfBaths?: number | null | undefined, diningRoom?: number | null | undefined, casualDining?: number | null | undefined, mediaRooms?: number | null | undefined, loftGameFlexRooms?: number | null | undefined, offices?: number | null | undefined, workspaces?: number | null | undefined, garageAttached?: number | null | undefined, garageDetached?: number | null | undefined, garagePort?: number | null | undefined, depthInFeet?: number | null | undefined, widthInFeet?: number | null | undefined, minLotSizeInSqft?: number | null | undefined, minLotDepthInFeet?: number | null | undefined, minLotWidthInFeet?: number | null | undefined, buildingHeightInFeet?: number | null | undefined, netBuildableSqft?: number | null | undefined, grossBuildableSqft?: number | null | undefined, permittableSqft?: number | null | undefined, sellableAboveGroundSqft?: number | null | undefined, grossBelowGroundSqft?: number | null | undefined, sellableBelowGroundSqft?: number | null | undefined, imperviousSqft?: number | null | undefined, sellableSqft?: number | null | undefined, unfinishedBelowGroundSqft?: number | null | undefined, primaryBedroom?: { __typename?: 'ProgramDataPrimaryBedroomConfigDetail', code: Types.ProgramDataPrimaryBedroomConfig, name: string } | null | undefined, basementConfig?: { __typename?: 'ProgramDataBasementConfigDetail', code: Types.ProgramDataBasementConfig, name: string } | null | undefined, garageConfiguration?: { __typename?: 'ProgramDataGarageConfigDetail', code: Types.ProgramDataGarageConfig, name: string } | null | undefined } };

export const ElevationDetails_ReadyPlanOptionFragmentDoc = gql`
    fragment ElevationDetails_ReadyPlanOption on ReadyPlanOption {
  id
  assets {
    id
    isCoverPhoto
    asset {
      id
      previewUrl(resizing: {width: 326, region: FULL})
    }
  }
  programData {
    id
    stories
    bedrooms
    firstFloorBedrooms
    primaryBedroom {
      code
      name
    }
    closetsInPrimarySuite
    fullBaths
    halfBaths
    diningRoom
    casualDining
    mediaRooms
    loftGameFlexRooms
    offices
    workspaces
    basementConfig {
      code
      name
    }
    garageConfiguration {
      code
      name
    }
    garageAttached
    garageDetached
    garagePort
    depthInFeet
    widthInFeet
    minLotSizeInSqft
    minLotDepthInFeet
    minLotWidthInFeet
    buildingHeightInFeet
    netBuildableSqft
    grossBuildableSqft
    permittableSqft
    sellableAboveGroundSqft
    grossBelowGroundSqft
    sellableBelowGroundSqft
    imperviousSqft
    sellableSqft
    unfinishedBelowGroundSqft
  }
}
    `;
export const ElevationDetailsDocument = gql`
    query ElevationDetails($id: ID!, $planPackageVersionId: ID!) {
  readyPlanOption(id: $id, versionId: $planPackageVersionId) {
    ...ElevationDetails_ReadyPlanOption
  }
}
    ${ElevationDetails_ReadyPlanOptionFragmentDoc}`;

/**
 * __useElevationDetailsQuery__
 *
 * To run a query within a React component, call `useElevationDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useElevationDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useElevationDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      planPackageVersionId: // value for 'planPackageVersionId'
 *   },
 * });
 */
export function useElevationDetailsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ElevationDetailsQuery, ElevationDetailsQueryVariables> & ({ variables: ElevationDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ElevationDetailsQuery, ElevationDetailsQueryVariables>(ElevationDetailsDocument, options);
      }
export function useElevationDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ElevationDetailsQuery, ElevationDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ElevationDetailsQuery, ElevationDetailsQueryVariables>(ElevationDetailsDocument, options);
        }
export function useElevationDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ElevationDetailsQuery, ElevationDetailsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ElevationDetailsQuery, ElevationDetailsQueryVariables>(ElevationDetailsDocument, options);
        }
export type ElevationDetailsQueryHookResult = ReturnType<typeof useElevationDetailsQuery>;
export type ElevationDetailsLazyQueryHookResult = ReturnType<typeof useElevationDetailsLazyQuery>;
export type ElevationDetailsSuspenseQueryHookResult = ReturnType<typeof useElevationDetailsSuspenseQuery>;
export type ElevationDetailsQueryResult = Apollo.QueryResult<ElevationDetailsQuery, ElevationDetailsQueryVariables>;